import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    gap: tokens.spacing['8'],
    borderRadius: tokens.radius.s,
    cursor: 'pointer',
    minHeight: tokens.spacing['40'],
    minWidth: tokens.spacing['40'],

    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
    },
  },

  active: {
    backgroundColor: tokens.colors.accent.bg.blue,

    '&:hover': {
      backgroundColor: tokens.colors.accent.bg.blue,
    },
  },

  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
}));
